import Resource from '../Resource'
import { orderBy } from 'lodash'
import { TextNormalization } from '@/shared/util/text-normalization'

class CommonDepartmentService extends Resource {
    async findAllActiveByCenter(centerId) {
        const response = await this.axios.get(`/departments/activeByCenter?centerId=${centerId}`)
        return orderBy(response.data, element => TextNormalization.removeDiacritics(element.name), ['asc'])
    }
}

export default new CommonDepartmentService()
